import { Pipe, PipeTransform } from '@angular/core';

/** Human-readable labels for UserRole (snake_case → Title Case) */
const ROLE_LABELS: Record<string, string> = {
  admin: 'Admin',
  contractor_dispatcher: 'Contractor Dispatcher',
  contractor_owner: 'Contractor Owner',
  driver: 'Driver',
  foreman: 'Foreman',
  mto_ceo: 'MTO CEO',
  trucking_dispatcher: 'Trucking Dispatcher',
  trucking_owner: 'Trucking Owner',
};

/**
 * Transforms a role key (e.g. trucking_owner) into a human-readable label (e.g. Trucking Owner).
 * Falls back to replacing underscores with spaces and title-casing for unknown roles.
 */
@Pipe({
  name: 'roleLabel',
  standalone: true,
})
export class RoleLabelPipe implements PipeTransform {
  transform(role: string | null | undefined): string {
    if (role == null || role === '') {
      return '';
    }
    const normalized = role.trim().toLowerCase();
    if (ROLE_LABELS[normalized]) {
      return ROLE_LABELS[normalized];
    }
    // Fallback: replace underscores with spaces, capitalize each word
    return normalized.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  }
}
